import { useEffect, useState } from "react";
import { SearchDateSingleForm } from "src/components/common/form/search/SearchDateSingleForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { usePRD4010_R01Store } from "./Store_PRD4010_R01";
import { CompanyDto } from "src/dtos/company/companyDto";
import { SysCodeDto, defaultSysCode_Modal } from "src/dtos/code/sysCodeDto";

/** SearchDropDownForm은 AnyDto(SysCodeDto 등)만 허용 — minorCd=값, codeNm=표시 */
const INTERVAL_OPTIONS: SysCodeDto[] = [
    { ...defaultSysCode_Modal, minorCd: "null", codeNm: "자동조회 OFF" },
    { ...defaultSysCode_Modal, minorCd: "1", codeNm: "1분" },
    { ...defaultSysCode_Modal, minorCd: "5", codeNm: "5분" },
    { ...defaultSysCode_Modal, minorCd: "10", codeNm: "10분" },
];

export const SearchSection_PRD4010_R01 = () => {
    const { PRD4010_R01Filter, setPRD4010_R01Filter } = usePRD4010_R01Store();
    const { compCdList } = useCommonCodeStore();
    const [pickerVisible, setPickerVisible] = useState(false);
    const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({
        top: 0,
        left: 0,
    });

    useEffect(() => {
        if (!compCdList?.length) return;
        if (PRD4010_R01Filter.compCd) return;
        const first = compCdList[0];
        if (first?.compCd) {
            setPRD4010_R01Filter({ compCd: first.compCd });
        }
    }, [compCdList, PRD4010_R01Filter.compCd, setPRD4010_R01Filter]);

    return (
        <SearchSectionForm>
            <SearchDropDownForm<CompanyDto>
                label="사업장"
                value={PRD4010_R01Filter.compCd}
                optionList={compCdList}
                initLabelLess
                onChangeValue={(v) => setPRD4010_R01Filter({ compCd: v })}
            />
            <SearchDateSingleForm
                label="작업일자"
                visible={pickerVisible}
                setVisible={setPickerVisible}
                value={PRD4010_R01Filter.searchDate}
                onChange={(date) => setPRD4010_R01Filter({ searchDate: date })}
                pickerPosition={pickerPosition}
                setPickerPosition={setPickerPosition}
            />
            <SearchDropDownForm<SysCodeDto>
                label="자동조회"
                value={PRD4010_R01Filter.autoRefreshInterval?.toString() ?? "null"}
                optionList={INTERVAL_OPTIONS}
                onChangeValue={(v) =>
                    setPRD4010_R01Filter({
                        autoRefreshInterval:
                            v === "null" || v === "" || v === defaultSysCode_Modal.minorCd
                                ? null
                                : Number(v),
                    })
                }
            />
        </SearchSectionForm>
    );
};
